import React from 'react';
import { format, parseISO } from 'date-fns';
import { DNABox, DNAButton, DNAChip, DNAText } from '@alucio/lux-ui';
import { Bulletin, BulletinStatus } from '@alucio/aws-beacon-amplify/src/models';
import { BulletinRichText } from './BulletinRichText';
import { parseBulletinContent } from './bulletin.utils';

interface Props {
  bulletin: Pick<Bulletin, 'title' | 'content'> & Partial<Pick<Bulletin, 'publishedAt' | 'status'>>;
  onEdit?: () => void;
  onWithdraw?: () => void;
}

export const BulletinPost: React.FC<Props> = ({ bulletin, onEdit, onWithdraw }) => {
  const content = parseBulletinContent(bulletin.content);
  return (
    <DNABox appearance="col" spacing="sm" style={{ minWidth: 0, width: '100%' }} testID="bulletin-post">
      <DNABox spacing="between" alignY="start" childFill={0} childStyle={[0, { minWidth: 0 }]}>
        <DNABox appearance="col" spacing="xs" shrink style={{ minWidth: 0, maxWidth: '100%' }}>
          <DNAText h3 bold>
            {bulletin.title}
          </DNAText>
          {bulletin.status === BulletinStatus.DRAFT && (
            <DNABox>
              <DNAChip appearance="subtle" status="primary" size="sm">DRAFT</DNAChip>
            </DNABox>
          )}
          {bulletin.publishedAt && (
            <DNAText status="tertiary">{format(parseISO(bulletin.publishedAt), 'MMMM d, yyyy')}</DNAText>
          )}
        </DNABox>
        {onEdit && onWithdraw && (
          <DNABox spacing="xs">
            <DNAButton
              appearance="outline"
              status="tertiary"
              iconLeft="pencil-simple"
              accessibilityLabel={'Edit ' + bulletin.title}
              onPress={onEdit}
              testID="bulletin-edit"
            />
            <DNAButton
              appearance="outline"
              status="tertiary"
              iconLeft="trash"
              accessibilityLabel={'Delete ' + bulletin.title}
              onPress={onWithdraw}
              testID="bulletin-withdraw"
            />
          </DNABox>
        )}
      </DNABox>
      {content ? (
        <BulletinRichText readOnly value={content} />
      ) : (
        <DNAText status="tertiary">This post’s content could not be displayed.</DNAText>
      )}
    </DNABox>
  );
};
